import { SubjectData } from 'shell/models/person';
import { BirthdayDocumentVM } from 'shell/view-models/birthday-document';
import { DateTime } from 'luxon';
import { ActType } from 'shell/constants/act-type';

export const transformBirthdayDocument = (person: SubjectData): BirthdayDocumentVM | undefined => {
  if (!(person.attoNascitaANPR?.atto || person.attoNascitaANPR?.attoANSC)) {
    return {
      actType: ActType.SenzaAtto,
    };
  }

  return {
    actType: person.attoNascitaANPR?.attoANSC
      ? ActType.AttoDigitale
      : person.attoNascitaANPR?.atto
      ? ActType.AttoCartaceo
      : ActType.SenzaAtto,
    paper: !person.attoNascitaANPR?.atto
      ? undefined
      : {
          actMunicipality: {
            id: person.attoNascitaANPR?.atto?.comuneRegistrazione?.codiceIstat || '',
            description: person.attoNascitaANPR?.atto?.comuneRegistrazione?.nomeComune || '',
            province: person.attoNascitaANPR?.atto?.comuneRegistrazione?.siglaProvinciaIstat || '',
          },
          actYear: person.attoNascitaANPR?.atto?.anno || '',
          actPart: person.attoNascitaANPR?.atto?.parte || '',
          actSeries: person.attoNascitaANPR?.atto?.serie || '',
          actNumber: person.attoNascitaANPR?.atto?.numeroAtto || '',
          actVolume: person.attoNascitaANPR?.atto?.volume || '',
          actDate: person.attoNascitaANPR?.atto?.dataFormazioneAtto
            ? DateTime.fromISO(person.attoNascitaANPR?.atto?.dataFormazioneAtto)
            : null,
          transcribed: person.attoNascitaANPR?.atto?.trascritto === '1' ? true : false,
        },
    digital: !person.attoNascitaANPR?.atto
      ? {
          documentDate: person.attoNascitaANPR?.attoANSC?.dataFormazioneAtto
            ? DateTime.fromISO(person.attoNascitaANPR?.attoANSC?.dataFormazioneAtto)
            : null,
          idAnsc: person.attoNascitaANPR?.attoANSC?.idANSC || '',
          istatCode: person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.codiceIstat || '',
          municipality: {
            id: person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.codiceIstat || '',
            description: person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.nomeComune || '',
            province:
              person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.siglaProvinciaIstat || '',
          },
          nationalNumber: (person.attoNascitaANPR?.attoANSC?.idANSC?.split('-') || [])[1],
          numberMunicipality: person.attoNascitaANPR?.attoANSC?.numeroComunale || '',
          year: person.attoNascitaANPR?.attoANSC?.anno || '',
          transcript: person.attoNascitaANPR?.attoANSC?.trascritto === '1' ? true : false,
        }
      : undefined,
  };
};
